import { SiteRoles } from '../../users/serverApi/types/ISiteRole';

export namespace SiteRolesUtil {

  export function isSiteAdmin(siteRole: string): boolean {
    return siteRole === SiteRoles.SiteAdministratorExplorer ||
      siteRole === SiteRoles.SiteAdministratorCreator ||
      siteRole === SiteRoles.SupportUser;
  }

  export function isCreatorOrServerAdmin(siteRole: string): boolean {
    return siteRole === SiteRoles.ServerAdministrator || siteRole === SiteRoles.SiteAdministratorCreator || siteRole === SiteRoles.Creator;
  }

  export function isExplorer(siteRole: string): boolean {
    return siteRole === SiteRoles.SiteAdministratorExplorer || siteRole === SiteRoles.ExplorerCanPublish || siteRole === SiteRoles.Explorer;
  }

  export function isSiteExplorerOrHigher(siteRole: string): boolean {
    return this.isSiteAdmin(siteRole) || siteRole === SiteRoles.ServerAdministrator || siteRole === SiteRoles.Creator || siteRole === SiteRoles.ExplorerCanPublish
    || siteRole === SiteRoles.Explorer;
  }

  export function canPublish(siteRole: string): boolean {
    return this.isSiteAdmin(siteRole) || siteRole === SiteRoles.ServerAdministrator || siteRole === SiteRoles.Creator || siteRole === SiteRoles.ExplorerCanPublish;
  }

  export function isSiteCreatorOrHigher(siteRole: string): boolean {
    return this.isSiteAdmin(siteRole) || siteRole === SiteRoles.Creator;
  }
}
